export const en = {
    noData: 'No data'
};
